module.exports = __webpack_public_path__ + "img/stock1.e7e8dddc.png";